import { modals } from '@mantine/modals';
import type { RecoveryPlanStep } from 'types/recovery-plan';

import { RecoveryTaskStepForm } from './RecoveryTaskStepForm';

type OpenRecoveryTaskStepModalOptions = {
  title: string;
  step?: RecoveryPlanStep;
  onSubmit: (step: RecoveryPlanStep) => void;
};

export const openRecoveryTaskStepModal = ({
  title,
  step,
  onSubmit,
}: OpenRecoveryTaskStepModalOptions) =>
  modals.open({
    title,
    size: 'xl',
    children: (
      <RecoveryTaskStepForm
        step={step}
        onSubmit={submittedStep => {
          onSubmit(submittedStep);
          modals.closeAll();
        }}
      />
    ),
  });
